import { ChangeDetectionStrategy, Component, input } from '@angular/core';

type ToastTone = 'success' | 'error' | 'info';

/**
 * Presentational toast. Rendered into a CDK overlay by ToastService.
 * Screen-reader announcement is handled by the service via LiveAnnouncer,
 * so this is aria-hidden to avoid double-announcing.
 */
@Component({
  selector: 'bolt-toast',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="toast bolt-overlay-animate" [class]="'tone-' + tone()" aria-hidden="true">
      <span class="toast-icon" [class]="tone()">
        @switch (tone()) {
          @case ('error') {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
              <path d="M6 6l12 12M6 18L18 6" />
            </svg>
          }
          @default {
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          }
        }
      </span>
      <span>{{ message() }}</span>
    </div>
  `,
  styles: `
    .toast-icon.error {
      background: var(--fail);
    }
    .toast-icon.info {
      background: var(--info);
    }
  `,
})
export class ToastComponent {
  readonly message = input.required<string>();
  readonly tone = input<ToastTone>('success');
}
